module.exports = __webpack_public_path__ + "img/icon-arrows-exchange.b36f4376.svg";